export const SET_TERMS = 'SET_TERMS';
export const setTermsAction = (terms) => ({
  type: SET_TERMS,
  payload: terms,
});
